import React, { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import * as api from "@nens/threedi/openapi-client";

import { getV3Api } from "../../apiConfiguration";
import { isEnabled } from "../../features";
import { getExistingRasterEdits } from "../../state/existingEvents";
import { menuExistingItemCardRow } from "../../styles/styleComposition";
import { simulationIdFromUrl } from "../../utils/apiUtils";

import * as layerRasterSourcesMenufrom from "./../../state/layerRasterSourcesMenu";
import ExistingItemCard from "./ExistingItemCard";

const ExistingRasterEdit: React.FC<{
  rasterEdit: api.RasterEdit;
  raster: api.Raster | null;
}> = ({ rasterEdit, raster }) => {
  const onDelete = useCallback(async () => {
    const v3Api = getV3Api();
    if (rasterEdit && rasterEdit.id && rasterEdit.simulation) {
      try {
        await v3Api.simulationsEventsRasterEditsDelete({
          id: rasterEdit.id,
          simulationPk: simulationIdFromUrl(rasterEdit.simulation),
        });
      } catch (e) {
        // XXX.
      }
    }
  }, [rasterEdit]);

  return (
    <ExistingItemCard
      onDelete={isEnabled("deleteRasterEdits") ? onDelete : undefined}
      start={rasterEdit.offset}
      controlType="deleteEdit"
    >
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage id="existingRasterEdits.raster_type" defaultMessage="Raster Type" />:
        </span>
        <span>
          {raster !== null ? (raster.type === "dem_file" ? "DEM" : "Interception") : "unknown"}
        </span>
      </div>
      <div className={menuExistingItemCardRow}>
        <span>
          <FormattedMessage id="existingRasterEdits.value" defaultMessage="Value" />:
        </span>
        <span>
          {rasterEdit.relative ? (rasterEdit.value >= 0 ? "+ " : "") : "= "}
          {rasterEdit.value}
          {raster && raster.type === "dem_file" ? "mMSL" : ""}
        </span>
      </div>
    </ExistingItemCard>
  );
};

const ExistingRasterEdits = () => {
  const existingRasterEditsEvents = useSelector(getExistingRasterEdits);

  const sourceRasters = useSelector(layerRasterSourcesMenufrom.getList);
  const demRaster = sourceRasters.find((raster) => raster.type === "dem_file");
  const interceptionRaster = sourceRasters.find((raster) => raster.type === "interception_file");

  return (
    <div>
      {existingRasterEditsEvents.map((existingItem) => {
        let raster: api.Raster | null = null;
        if (demRaster && existingItem.raster === demRaster.url) {
          raster = demRaster;
        }
        if (interceptionRaster && existingItem.raster === interceptionRaster.url) {
          raster = interceptionRaster;
        }

        return (
          <ExistingRasterEdit key={existingItem.url} rasterEdit={existingItem} raster={raster} />
        );
      })}
    </div>
  );
};

export default ExistingRasterEdits;
